export const cifNe = ["301 259","<g fill-rule='nonzero' fill='none'><path fill='#0DB02B' d='M.5.928h300v257.143H.5z'/><path fill='#FFF' d='M.5.928h300v171.429H.5z'/><path fill='#E05206' d='M.5.928h300v85.714H.5z'/><circle fill='#E05206' cx='150.5' cy='129.5' r='36.429'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-ne.js
// module id = null
// module chunks = 